import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import NewsletterForm from "@/components/NewsletterForm";

const nav = [
  { label: "Home", to: "/" },
  { label: "What We Do", to: "/what-we-do" },
  { label: "Who We Serve", to: "/who-we-serve" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1F2D4E] text-white">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.3fr_1fr_1.2fr]">
          <div>
            <img src="/assets/logo-wordmark-white.webp" alt="Reform Intelligence®" className="h-12 w-auto" />
            <p className="mt-6 text-sm leading-relaxed text-white/70">
              Reform Intelligence AI, Inc. A Delaware public benefit corporation.
            </p>
            <div className="mt-6 flex flex-col gap-3 text-sm text-white/80">
              <a href="mailto:contact@reformintelligence.com" data-testid="footer-email" className="flex items-center gap-2 transition-colors hover:text-[#D9C08A]">
                <Mail size={15} /> contact@reformintelligence.com
              </a>
              <a
                href="https://www.linkedin.com/company/reform-intelligence-ai"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="flex items-center gap-2 transition-colors hover:text-[#D9C08A]"
              >
                <Linkedin size={15} /> LinkedIn
              </a>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D9C08A]">Navigate</p>
            <div className="mt-5 flex flex-col gap-3">
              {nav.map((l) => (
                <Link key={l.to} to={l.to} className="text-sm text-white/75 transition-colors hover:text-white">
                  {l.label}
                </Link>
              ))}
              <Link to="/privacy" data-testid="footer-privacy" className="text-sm text-white/75 transition-colors hover:text-white">Privacy Policy</Link>
              <Link to="/terms" data-testid="footer-terms" className="text-sm text-white/75 transition-colors hover:text-white">Terms of Use</Link>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D9C08A]">Research</p>
            <p className="mt-5 text-sm text-white/75">Get our research. Enter your email.</p>
            <div className="mt-4">
              <NewsletterForm dark testid="footer-newsletter" />
            </div>
          </div>
        </div>
        <div className="mt-14 border-t border-white/15 pt-8">
          <p className="text-xs leading-relaxed text-white/50">
            © 2026 Reform Intelligence AI, Inc. All rights reserved. Reform Intelligence® is a trademark of Reform Intelligence AI, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
}
